import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BackboneAdapterService } from '../../../shared/backbone-adapter.service';
import { GTMService } from '../../../shared/gtm.service';
import { NotificationService } from '../../../shared/notification.service';
import { OneSignalService } from '../../../shared/one-signal.service';
import { LiveClassDto } from '../../../shared/types/LiveClassDto';
import { LiveClassEventService } from '../../live-class-event.service';
import { LiveClassTile } from '../../live-class-section/class-tile/live-class-tile';
import { PrivateClassTile } from '../../live-class-section/class-tile/private-class-tile';
import { LiveClassService } from '../../live-class.service';
import { LiveClassLessonTrack } from '../live-class-lesson-track-dto';
import { LESSON_SELECT_WAIT_TIME } from '../live-class-revamp.module';
import { PrivateClassLesson } from './private-class-lesson-dto';
import { PrivateClassTrackService } from './private-class-track/private-class-track.service';

@Component({
  selector: 'lp2-private-class-banner',
  templateUrl: './private-class-banner.component.html',
})
export class PrivateClassBannerComponent implements OnInit, OnChanges {
  @Input() liveClass: LiveClassDto;
  @Input() track: LiveClassLessonTrack;
  public lessons$ = new BehaviorSubject<PrivateClassLesson[]>(null);
  public lessonsWithFreeFormTopic$ = new BehaviorSubject<PrivateClassLesson[]>(null);
  public liveClassTile: PrivateClassTile;

  constructor(
    private privateClassTrackService: PrivateClassTrackService,
    private liveClassService: LiveClassService,
    private liveClassEventService: LiveClassEventService,
    private notificationService: NotificationService,
    private backbone: BackboneAdapterService,
    private gtmService: GTMService,
    private oneSignalService: OneSignalService
  ) {}

  ngOnInit() {
    this.privateClassTrackService.getPrivateClassLessons(this.track.uuid).subscribe((res) => this.lessons$.next(res));
    this.privateClassTrackService
      .getPrivateClassLessonsWithFreeFormTopic(this.track.uuid)
      .subscribe((res) => this.lessonsWithFreeFormTopic$.next(res));
  }

  ngOnChanges() {
    if (this.liveClassTile) {
      this.liveClassTile.destroy();
    }
    this.liveClassTile = new PrivateClassTile(
      this.liveClassService,
      this.liveClassEventService,
      this.notificationService,
      this.backbone,
      this.gtmService,
      this.oneSignalService,
      'pcrevamp',
      this.liveClass
    );
  }

  onLessonSelect(lessonId: number) {
    const lesson = this.lessonsWithFreeFormTopic$.value.find((l) => l.id === lessonId);
    this.liveClassTile.selectedLesson = lesson;
    setTimeout(() => this.onClick(), LESSON_SELECT_WAIT_TIME);
  }

  onClick() {
    this.liveClassTile.onTileClick(this.liveClassTile.selectedLessonId, this.lessonsWithFreeFormTopic$.value);
  }

  onCancel(event: Event) {
    if (this.liveClassTile instanceof LiveClassTile) {
      this.liveClassTile.onCancel(event);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-banner.component.ts